<template>
  <van-popup v-model="show" position="right" style="width: 100%" @opened="initData">
    <div class="container container-nav container-footer">
      <van-nav-bar title="福利待遇" left-arrow fixed ref="navBarH" @click-left="show=false"/>

      <section class="select-job-top-content flex all-t">
        <div class="ds-job-select-item flex-1" :style="{height:'calc(100vh - '+ jobTopH +')'}">
          <h3 class="f14 divider txt-l mb10">
            <span class="pl0">福利待遇</span>
          </h3>
          <p class="clearfix">
            <span
              class="van-bor1 van-hairline--surround"
              v-for="(item,index) in cateList"
              :class="{'selected':selectItem.indexOf(item.fldyName)>-1}"
              :key="index" @click="onCheck(item)">{{item.fldyName}}
            </span>
          </p>
        </div>
      </section>

      <footer class="footer-fixed flex all-c" ref="footerH">
        <van-button block type="primary" class="flex-1 btn-gradient radius-0" @click="sure">
          <span class="f18">确定</span>
        </van-button>
      </footer>
    </div>
  </van-popup>
</template>

<script>
  import api from '../../../api';
  export default {
    data() {
      return {
        show: false,
        jobTopH: 0,
        cateList: [],
        firstIndex: 0,
        selectItem: [],      // 选中的名称列表（用于显示）
        selectIdList: []     // 选中的ID列表（用于传参）
      };
    },
    props: {
      defaultList: {
        type: Array,
        default: () => []
      },
      defaultIdList: {
        type: Array,
        default: () => []
      }
    },
    methods: {
      async getCategorys() {
        try {
          const result = await api.get('/api/vpai/recruit/list_welfares');
          // 新接口返回格式: { code: 10000, data: [{ fldyId, fldyName }] }
          this.cateList = Array.isArray(result) ? result : (result.data || []);
          this.$loadingClose();
        } catch (e) {
          this.$toast(e.message);
        }
      },
      async initData() {
        this.jobTopH = this.$refs.navBarH.offsetHeight + this.$refs.footerH.offsetHeight - 2 + 'px';
        console.log('jobTopH---', this.cateList);
        if (!this.cateList.length) {
          await this.getCategorys();
        }
        this.selectItem = [...this.defaultList];
        this.selectIdList = [...this.defaultIdList];
      },
      onCheck(item) {
        let index = this.selectItem.indexOf(item.fldyName);
        if (index > -1) {
          this.selectItem.splice(index, 1);
          this.selectIdList.splice(index, 1);
        } else {
          this.selectItem.push(item.fldyName);
          this.selectIdList.push(item.fldyId);
        }
      },
      sure() {
        this.$emit('sure', { nameList: this.selectItem, idList: this.selectIdList });
        this.show = false;
      }
    }
  };
</script>

<style lang="less">
  @import '../../../assets/css/theme.less';

  .ds-job-select-cat {
    width: 97px;
    overflow: auto;
    background: darken(@bgLightGray, 1.2%);
    text-align: center;
    position: relative;
  }

  .ds-job-select-cat > p {
    color: #666;
    line-height: 43px;
    padding: 0 5px;
  }

  .ds-job-select-cat > p.active {
    color: @primaryColor;
    background: @white;
    border-color: @white;
  }

  .ds-job-select-item {
    padding: 10px;
    box-sizing: border-box;
    overflow: auto;
  }

  .ds-job-select-item > p > span {
    color: #666;
    font-size: 12px;
    line-height: 28px;
    float: left;
    margin: 0 10px 10px 0;
    padding: 0 12px;
  }

  .ds-job-select-item > p > span.selected {
    color: @primaryColor;
    background: url('../../../assets/images/feedback/yes.png') no-repeat right bottom @white;
    background-size: 18px 13px;
  }

  .ds-job-select-item > p > span.van-hairline--surround::after {
    border-radius: 6px;
  }

  .ds-job-select-item > p > span.selected.van-hairline--surround::after {
    border-color: @primaryColor;
  }
</style>
